define('model/BookingModel',['require','lib/model/BaseModel','underscore','lib/validator/ValidatorEmail','lib/validator/ValidatorPhone','lib/validator/ValidatorIntlPhone','lib/validator/ValidatorNotEmpty','Config'],function (require) {

	var BaseModel = require('lib/model/BaseModel');
	var _ = require('underscore'); // pin to Underscore: global window._ may be a lodash build that drops the _.each context arg
	var ValidatorEmail = require('lib/validator/ValidatorEmail');
	var ValidatorPhone = require('lib/validator/ValidatorPhone');
	var ValidatorIntlPhone = require('lib/validator/ValidatorIntlPhone');
	var ValidatorNotEmpty = require('lib/validator/ValidatorNotEmpty');
	var Config = require('Config');

	/**
	 * Single booking data model
	 * 
	 * @class BookingModel
	 */
	return BaseModel.extend({
		
		url: '/booking/',
		url_waiting_list: '/v2/waiting-list/',
		
		defaults: {
			id: null,
			location_id: null,
			category_id: null,
			service_id: null,
			provider_id: null,
			start_date: null,
			start_time: null,
			end_date: null,
			end_time: null,
			code: null,
			hash: null,
			client_name: '',
			client_email: '',
			client_phone: '',
			promo_code: null,
            price_with_tax: null,
            price_without_tax: null,
			products: [],
			count: 1,
			with_deposit: false,
			is_pay_full_price_without_deposit: false,
            sheduler_channel: null
		},
        
        allowRedirectOnAnyProvider: true,
		
		initialize: function () {
			this.validators = {
				'client_name': [new ValidatorNotEmpty()],
				'client_email': [new ValidatorEmail()],
				'client_phone': []
			};

			var config = Config.getInstance();
			if (!config.getPluginStatus('client_login')) {
                if (config.getOption('client_email_required')) {
                    this.validators.client_email.push(new ValidatorNotEmpty());
                }
                //console.log(config.getOption('client_phone_required'));
                if (config.getOption('client_phone_required')) {
                    this.validators.client_phone.push(new ValidatorNotEmpty());
                }
                this.validators.client_phone.push(new ValidatorIntlPhone({
					allowedPrefix: config.getOption('country_prefix_is_changeable')?null:config.getOption('country_prefix'),
					checkPhoneRequired : true,
				}));
            }

            this.updatePredefinedClientInfo();

			this.listenTo(Config.getInstance(), 'config:changed', this.updatePredefinedClientInfo);

			// var _this = this;
			// this.listenTo(this, 'change:count', function () {
			// 	console.log(_this.get('count'));
			// });

			this.set('sheduler_channel', config.getOption('sheduler_channel'));

			BaseModel.prototype.initialize.call(this);
		},

		updatePredefinedClientInfo: function () {
			var isClientDataSet = this.get('client_name') || this.get('client_email') || this.get('client_phone'); 
            var predefined = Config.getInstance().getOption('predefined') || {};
            if (predefined.client && !isClientDataSet) {
                this.set({
                    'client_name': predefined.client.name,
                    'client_email': predefined.client.email,
                    'client_phone': predefined.client.phone
                });
            }
		},

		toJSON: function (options) {
			var result = Backbone.Model.prototype.toJSON.apply(this, [options]);

			var time = '';
			if (this.get('start_time')) {
				time += ' ' + this.get('start_time');
			}

            var service = this.get('service');
            // var duration = service ? service.duration * 60 * 1000 : 0;
            // var buffertimeAfter = service ? service.buffertime_after * 60 * 1000 : 0;
            // var buffertimeBefore = service ? service.buffertime_before * 60 * 1000 : 0;

			var startDateTime = result.start_datetime_raw = Date.parseMysqlDate(this.get('start_date') + time);
            // result.start_datetime = new Date(startDateTime.getTime() + buffertimeBefore);
            result.start_datetime = new Date(startDateTime.getTime());

			if (this.get('end_date') && this.get('end_time')) {
				var endDateTime = result.end_datetime_raw = Date.parseMysqlDate(this.get('end_date') + ' ' + this.get('end_time'));
                // result.end_datetime = new Date(endDateTime.getTime() - buffertimeBefore - buffertimeAfter);
                result.end_datetime = new Date(endDateTime.getTime());
			}

			result.prices = this.getPrices();

			return result;
		},

		getPrices: function () {
			var config = Config.getInstance();

			var result = {
				'items': [],
				'totals': null
			};

            var booking = {};
            var service = this.get('service');
            if (service) {
                booking.name = service.name;
                booking.type = 'service';
            }
            var depositAllowed = false;
            if (service && service.price) {
            	var price = parseFloat(service.price);
            	if (this.get('discount_rate')) {
                    price = price - (price * this.get('discount_rate'));
				}
				booking.price = price;
                booking.tax = service.tax;
                booking.currency = service.currency;
                booking.duration = service.duration;
                booking.qty = this.get('count') || 1;

				if (config.getPluginStatus('deposit_paid_events') && service.deposit_is_enabled === '1') {
					booking.deposit = parseFloat(service.deposit);
					depositAllowed = true;
				}
			}

            if (booking.price > 0) {
				// adjust quantity for recurring bookings
				if (service && service.recurring_settings && service.recurring_settings.price_per_session == 1) {
					if (this.get('dates') && this.get('dates').length) {
						booking.qty *= this.get('dates').length;
					}
				}

                result.items.push(booking);
            }

			if (this.get('products')) {
            	var count = this.get('count') || 1;
            	if (this.get('dates') && this.get('dates').length) {
            		count = this.get('dates').length;
				}

				_.each(this.get('products'), function (product) {
					var qty = product.qty * (product.type == 'attribute' ? count : 1);
						
					result.items.push({
						'name': product.name,
						'type': product.type,
						'currency': product.currency,
						'duration': product.duration,
						'price': parseFloat(product.price),
						'deposit': depositAllowed && parseInt(product.add_to_deposit) ? parseFloat(product.price) : 0,
                        'tax': product.tax,
						'qty': qty
					});
				}, this);
			}

			if (result.items.length) {
                result.totals = this._getTotals(result.items);
            }

			return result;
		},

		_getTotals: function (rows) {
			var taxes = {};
			var result = {
				'taxes': [],
				'total': 0,
				'totalDeposit': 0,
				'currency': null
			};
			_.each(rows, function (row) {
				result.currency = row.currency;

				var amount = row.price * row.qty;
                if (!Config.getInstance().getOption('price_includes_tax') && row.tax) {
                    amount *= 1 + row.tax.ratio;
                }

                result.total += amount;

                if (row.deposit) {
					result.totalDeposit += row.deposit * row.qty;
				}

                if (row.tax) {
                    var taxAmount = amount - (amount / (1 + row.tax.ratio));
                    if (taxAmount > 0) {
                        if (!taxes[row.tax.id]) {
                            var tax = {
                                'id': row.tax.id,
                                'name': row.tax.name,
                                'amount': 0
                            };
                            result.taxes.push(tax);
                            taxes[row.tax.id] = tax;
                        }

                        taxes[row.tax.id].amount += taxAmount;
                    }
                }
			});

			return result;
		},
        
        getAddons: function () {
            var ids = _.pluck(
                _.where(this.get('products'), {type: 'attribute'}),
                'id'
            );
            if (_.isEmpty(ids)) return undefined;
            
            return ids.join(',');
        },
        
        getProductsAddonsList: function () {
            return this.get('products');
        }
		
	});
	
});
